export const DATE_FORMAT = `MMM DD, YYYY`;
export const CHARTS_INPUT_DATE_FORMAT = `YYYY-MM`;
export const CHARTS_OUTPUT_DATE_FORMAT = `MMM YYYY`;
